document.addEventListener("DOMContentLoaded", () => {
    initRecommendationPage();
});

let recommendationData = null;

async function initRecommendationPage() {
    const loader = document.getElementById("recommendation-loader");
    const error = document.getElementById("recommendation-error");
    const content = document.getElementById("recommendation-content");
    const skinnIngredients = document.getElementById("skinn-ingredients");

    loader.style.display = "block";
    error.style.display = "none";
    content.style.display = "none";
    if (skinnIngredients) {
        skinnIngredients.style.display = "none";
    }

    const params = new URLSearchParams(window.location.search);
    const respId = params.get("resp_id");

    if (!respId) {
        loader.style.display = "none";
        error.style.display = "block";
        error.innerHTML = "Recommendation not found.";
        return;
    }

    try {
        const apiUrl =
            `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${respId}&self_serve=true&multiple_recommendation_sections=true`;
        console.log("Fetching:", apiUrl);
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error("API Error");
        }
        recommendationData = await response.json();
        console.log("Recommendation Data:", recommendationData);
        renderRecommendationPage(recommendationData);
        loader.style.display = "none";
        content.style.display = "block";
        if (skinnIngredients) {
            skinnIngredients.style.display = "block";
        }
        if (recommendationData.selfie_id) {
            requestAnimationFrame(() => {
                getSelfieMapping(recommendationData.selfie_id);
            });
        }
    } catch (e) {
        console.error(e);
        loader.style.display = "none";
        error.style.display = "block";
        error.innerHTML = "Unable to load recommendations.";
        if (skinnIngredients) {
            skinnIngredients.style.display = "block";
        }
    }
}

function getProductSellingPlanId(product) {
    const sellingPlanId =
        product?.sellingPlanGroups?.edges?.[0]
            ?.node?.sellingPlans?.edges?.[0]
            ?.node?.id;

    if (!sellingPlanId) return "";

    return String(sellingPlanId).split("/").pop();
}

function isAvailableForSale(product, variant) {
    if (variant) {
        if (variant.availableForSale === false) return false;
        if (variant.available === false) return false;
    }

    if (product) {
        if (product.availableForSale === false) return false;
        if (product.available === false) return false;
        if (String(product.status || "").toUpperCase() === "DRAFT") return false;
        if (product.publishedAt === null) return false;
    }

    return true;
}

function findProductByTitle(products, title) {
    const normalizedTitle = normalizeTitle(title);

    if (!normalizedTitle) return null;

    return (products || []).find(product => {
        if (!product?.title) return false;

        const normalizedProduct = normalizeTitle(product.title);

        return (
            normalizedProduct === normalizedTitle ||
            normalizedProduct.includes(normalizedTitle) ||
            normalizedTitle.includes(normalizedProduct)
        );
    }) || null;
}

function findProductById(products, id) {
    const normalizedId = normalizeShopifyId(id);
    if (!normalizedId) return null;

    return (products || []).find(product =>
        normalizeShopifyId(product?.id) === normalizedId ||
        normalizeShopifyId(product?.legacyResourceId) === normalizedId
    ) || null;
}

function getProductSectionItems(productSections, products, sectionKey) {
    const ids = productSections?.[sectionKey];
    if (!Array.isArray(ids) || !ids.length) return [];

    return ids.map(function (id) {
        const product = findProductById(products, id);
        if (!product) return null;

        return {
            product: product.title,
            productRef: product
        };
    }).filter(Boolean);
}

function getProductImageUrls(product) {
    const nodes = product?.images?.nodes || product?.images || [];
    const urls = (Array.isArray(nodes) ? nodes : [])
        .map(img => img?.url || img?.src || "")
        .filter(Boolean);

    if (!urls.length && product?.image?.src) {
        urls.push(product.image.src);
    }

    return urls;
}

function renderProductImageMarkup(product, productUrl) {
    const urls = getProductImageUrls(product);
    const primary = urls[0] || "";
    const hover = urls[1] || "";

    return `
            <div class="recommendation-image${hover ? " has-hover-image" : ""}">
                <a href="${productUrl}">
                    <img
                        class="recommendation-image-primary"
                        src="${primary}"
                        alt="${product.title}"
                    >
                    ${hover ? `
                        <img
                            class="recommendation-image-hover"
                            src="${hover}"
                            alt=""
                            aria-hidden="true"
                        >
                    ` : ""}
                </a>
            </div>
    `;
}

function getSectionConfigItems(concern, skinType, textureType, sectionKey) {
    const isTextureSection =
        sectionKey === "section_cleanser" ||
        sectionKey === "section_exfoliation";

    if (textureType && isTextureSection) {
        const textureOverride = getTextureOverride(textureType, sectionKey);

        if (Array.isArray(textureOverride) && textureOverride.length) {
            return textureOverride;
        }
    }

    const items = routineConfig?.[concern]?.[skinType]?.[sectionKey];
    return Array.isArray(items) ? items : [];
}

function getRoutineSectionKeys(concern, skinType, textureType, productSections) {
    const ordered = [
        "section_cleanser",
        "section_exfoliation",
        "section_treatment_serum",
        "section_cream",
        "section_eye_care"
    ];

    const concernSections = routineConfig?.[concern]?.[skinType] || {};

    Object.keys(concernSections).forEach(key => {
        if (!ordered.includes(key)) ordered.push(key);
    });

    return ordered.filter(sectionKey =>
        getSectionConfigItems(concern, skinType, textureType, sectionKey).length ||
        (Array.isArray(productSections?.[sectionKey]) && productSections[sectionKey].length)
    );
}

function renderRecommendationPage(data) {

    renderSelfieSection(data);

    const container = document.getElementById("recommendation-sections");

    container.innerHTML = `
        <div class="routine-page-heading">
            <h2>Your Personalized Routine</h2>
            <p class="recommendation-count"></p>
        </div>

        <div class="recommendation-grid"></div>
        <div class="recommendation-add-all-wrap" hidden>
            <button type="button" class="add-all-to-cart-btn">Add All to Cart</button>
            <p class="recommendation-add-all-promo">Use code <strong>START15</strong> to get 15% off on above products</p>
        </div>
    `;

    const grid = container.querySelector(".recommendation-grid");

    const tags = Array.isArray(data.tags) ? data.tags : [];
    const concern = getConcern(tags);
    const skinType = getSkinType(tags);
    const textureType = getTextureType(tags);

    const products = data.products || [];
    const productSections = data.product_sections || {};
    const sectionKeys = getRoutineSectionKeys(
        concern,
        skinType,
        textureType,
        productSections
    );

    console.log("Routine config:", {
        concern,
        skinType,
        textureType,
        sectionKeys
    });

    const displayedProductIds = [];

    sectionKeys.forEach(sectionKey => {
        let configItems = getSectionConfigItems(
            concern,
            skinType,
            textureType,
            sectionKey
        );

        if (!configItems.length) {
            configItems = getProductSectionItems(
                productSections,
                products,
                sectionKey
            );
        }

        configItems.forEach((configItem, index) => {
            const product =
                configItem.productRef ||
                findProductByTitle(products, configItem.product);

            if (!product) {
                console.warn(
                    "Routine config product not found in API:",
                    sectionKey,
                    configItem.product
                );
                return;
            }

            const cardHtml = createProductCard(
                concern,
                skinType,
                textureType,
                sectionKey,
                index,
                product,
                configItem.product
            );

            if (!cardHtml) return;

            grid.insertAdjacentHTML("beforeend", cardHtml);
            displayedProductIds.push(String(product.id));
            if (product.legacyResourceId) {
                displayedProductIds.push(String(product.legacyResourceId));
            }
        });
    });

    const addAllWrap = container.querySelector(".recommendation-add-all-wrap");
    if (addAllWrap && grid.querySelector(".recommendation-card")) {
        addAllWrap.hidden = false;
    }

    attachAddToCartEvents();
    renderIngredientSection(data);
    renderHowToUseSection(data);
    filterHowToUseProducts(displayedProductIds);
    assignHowToUseTiming();
}

function getTextSectionHtml(data, key) {
    const sections = data.text_sections || {};
    const value = sections[key];

    if (!value) return "";
    if (Array.isArray(value)) return value.join("");
    return String(value);
}

function renderIngredientSection(data) {
    const container = document.getElementById("recommendation-ingredient");
    if (!container) return;

    const html =
        getTextSectionHtml(data, "section_ingredient") ||
        getTextSectionHtml(data, "section_ingredients");

    if (!html.trim()) {
        container.hidden = true;
        container.innerHTML = "";
        return;
    }

    container.innerHTML = html;
    container.hidden = false;
}

function renderHowToUseSection(data) {
    const container = document.getElementById("recommendation-how-to-use");
    if (!container) return;

    const html = getTextSectionHtml(data, "section_how_to_use");

    if (!html.trim()) {
        container.hidden = true;
        container.innerHTML = "";
        return;
    }

    container.innerHTML = html;
    container.hidden = false;
}

function normalizeShopifyId(id) {
    return String(id || "").split("/").pop();
}

function itemMatchesProductTitle(item, productTitle) {
    const normalizedTitle = normalizeTitle(productTitle);
    if (!normalizedTitle || normalizedTitle.length < 4) return false;

    const nameEl = getHowToUseNameElement(item, productTitle);
    if (!nameEl) return false;

    const name = normalizeTitle(nameEl.textContent);
    return (
        name === normalizedTitle ||
        name.includes(normalizedTitle) ||
        normalizedTitle.includes(name)
    );
}

function getHowToUseItemId(item) {
    return normalizeShopifyId(
        item.getAttribute("data-productid") ||
        item.getAttribute("data-product-id")
    );
}

function flattenHowToUseProductItems(root) {
    if (!root) return;

    let nested = root.querySelector(".sk-product-item .sk-product-item");
    while (nested) {
        nested.parentElement.after(nested);
        nested = root.querySelector(".sk-product-item .sk-product-item");
    }
}

function getDisplayedRoutineProducts() {
    return [...document.querySelectorAll("#recommendation-sections .recommendation-card")].map(card => ({
        id: normalizeShopifyId(card.getAttribute("data-product-id")),
        title: (card.querySelector(".product-title")?.textContent || "").replace(/\s+/g, " ").trim(),
        stepTitle: (card.querySelector(".product-step")?.textContent || "").replace(/\s+/g, " ").trim(),
        sectionKey: card.getAttribute("data-section-key") || ""
    }));
}

function findHowToUseItemForProduct(items, used, product, displayedIds) {
    const unused = items.filter(item => !used.has(item));

    const idMatch = unused.find(item => {
        const id = getHowToUseItemId(item);
        return id && id === product.id;
    });
    if (idMatch) return idMatch;

    return unused.find(item => {
        const id = getHowToUseItemId(item);
        if (id && displayedIds.has(id) && id !== product.id) return false;
        return itemMatchesProductTitle(item, product.title);
    }) || null;
}

function setHowToUseStepTitle(item, stepTitle) {
    if (!stepTitle) return;

    let titleEl = getHowToUseStepTitleElement(item);
    if (!titleEl) {
        titleEl = document.createElement("h3");
        titleEl.className = "sk-step-title";
        item.insertBefore(titleEl, item.firstChild);
    }

    titleEl.textContent = stepTitle;
    titleEl.style.display = "";
}

function filterHowToUseProducts(displayedProductIds) {
    const root = document.getElementById("recommendation-how-to-use");
    if (!root) return;

    flattenHowToUseProductItems(root);

    const items = [...root.querySelectorAll(".sk-product-item")];
    if (!items.length) return;

    const displayedProducts = getDisplayedRoutineProducts();
    const displayedIds = new Set(
        displayedProducts.map(product => product.id).filter(Boolean)
    );

    (displayedProductIds || []).forEach(function (id) {
        const normalizedId = normalizeShopifyId(id);
        if (normalizedId) displayedIds.add(normalizedId);
    });

    const used = new Set();
    const orderedMatches = [];

    displayedProducts.forEach(function (product) {
        const match = findHowToUseItemForProduct(items, used, product, displayedIds);
        if (!match) return;

        used.add(match);
        orderedMatches.push({ item: match, product });
    });

    items.forEach(function (item) {
        item.style.display = used.has(item) ? "" : "none";
    });

    const header = root.querySelector(".sk-routine-head");
    let insertAfter = header || null;

    orderedMatches.forEach(function ({ item, product }) {
        setHowToUseStepTitle(item, product.stepTitle);

        if (insertAfter) {
            insertAfter.after(item);
        } else {
            root.insertBefore(item, root.firstChild);
        }

        insertAfter = item;
    });

    dedupeHowToUseStepTitles(root);
    enhanceHowToUseLayout(root);
}

function getHowToUseStepTitleElement(item) {
    return item.querySelector(".sk-step-title") ||
        [...item.querySelectorAll("h1, h2, h3, h4, h5, h6")].find(el =>
            isHowToUseStepName(el.textContent)
        ) || null;
}

function normalizeHowToUseStepTitle(text) {
    return String(text || "").replace(/\s+/g, " ").trim().toLowerCase();
}

function dedupeHowToUseStepTitles(root) {
    if (!root) return;

    let lastStep = "";

    [...root.querySelectorAll(".sk-product-item")].forEach(item => {
        const titleEl = getHowToUseStepTitleElement(item);
        if (!titleEl) return;

        if (item.style.display === "none") {
            titleEl.style.display = "";
            return;
        }

        const step = normalizeHowToUseStepTitle(titleEl.textContent);
        if (!step) return;

        if (step === lastStep) {
            titleEl.style.display = "none";
            return;
        }

        titleEl.style.display = "";
        lastStep = step;
    });
}

function enhanceHowToUseLayout(root) {
    if (!root) return;

    let markedSectionStart = false;

    [...root.querySelectorAll(".sk-product-item")].forEach(item => {
        const isHidden = item.style.display === "none";
        const titleEl = getHowToUseStepTitleElement(item);
        const isFirstInStep = Boolean(
            !isHidden && titleEl && titleEl.style.display !== "none"
        );

        item.classList.toggle("is-hidden", isHidden);
        item.classList.toggle("is-first-in-step", isFirstInStep);
        item.classList.toggle("is-continued-step", !isHidden && !isFirstInStep);
        item.classList.toggle("is-section-start", false);

        if (!isHidden && !markedSectionStart) {
            item.classList.add("is-section-start");
            markedSectionStart = true;
        }
    });

    root.querySelectorAll(".sk-tip").forEach(tip => {
        if (tip.querySelector(".sk-tip-avatar-wrap")) return;

        tip.innerHTML = tip.innerHTML.replace(
            /^(Dimitri['’]s Tip:)([\s\S]*)$/i,
            '<span class="sk-tip-avatar-wrap"><img class="sk-tip-avatar" src="https://cdn.shopify.com/s/files/1/0271/5172/8714/files/dimitri-bw.jpg?v=1789633157" alt="Dimitri"></span><span class="sk-tip-copy"><strong class="sk-tip-label">$1</strong>$2</span>'
        );
    });
}

function formatTimingLabel(timing) {
    const value = String(timing || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    if (!value) return "";

    const parts = [];
    if (/\bAM\b/i.test(value)) parts.push("AM");
    if (/\bPM\b/i.test(value)) parts.push("PM");
    if (/daily|\bevery day\b/i.test(value)) parts.push("Daily");
    if (/every\s+other\s+week/i.test(value)) {
        parts.push("Every Other Week");
    } else if (/week/i.test(value)) {
        const countMatch = value.match(/(\d+(?:\s*[-–]\s*\d+)?)\s*[x×]/i);
        parts.push(countMatch ? countMatch[1].replace(/\s*[-–]\s*/, "-") + "X Weekly" : "Weekly");
    }

    return parts.join(" / ");
}

function isHowToUseStepName(text) {
    const value = String(text || "").replace(/\s+/g, " ").trim();
    if (!value) return true;

    return (
        /^\s*step\s*\d+/i.test(value) ||
        /^(cleanser|exfoliation|treatment|moisturizer|moisturiser|eye care|serum)(\s|$)/i.test(value)
    );
}

function getHowToUseNameElement(item, productTitle) {
    const candidates = [...item.querySelectorAll(
        "h1, h2, h3, h4, h5, h6, p, strong, b, a, span, .sk-product-name, .product-name, .sk-product-title"
    )];

    if (productTitle) {
        const normalizedTitle = normalizeTitle(productTitle);
        const match = candidates.find(el => {
            if (el.querySelector(".how-to-use-timing")) return false;
            if (isHowToUseStepName(el.textContent)) return false;

            const text = normalizeTitle(el.textContent);
            return text && (
                text === normalizedTitle ||
                text.includes(normalizedTitle) ||
                normalizedTitle.includes(text)
            );
        });
        if (match) return match;
    }

    return candidates.find(el => {
        if (el.querySelector(".how-to-use-timing")) return false;
        const text = (el.textContent || "").replace(/\s+/g, " ").trim();
        return text && !isHowToUseStepName(text);
    }) || null;
}

function assignHowToUseTiming() {
    const cards = [...document.querySelectorAll("#recommendation-sections .recommendation-card")];
    const timingById = new Map();

    cards.forEach(card => {
        const id = normalizeShopifyId(card.getAttribute("data-product-id"));
        const label =
            card.getAttribute("data-timing-label") ||
            formatTimingLabel(card.querySelector(".product-timing")?.textContent);

        if (id && label) timingById.set(id, {
            label,
            title: card.querySelector(".product-title")?.textContent || ""
        });
    });

    document.querySelectorAll(".sk-product-item").forEach(item => {
        if (item.style.display === "none") return;
        if (item.querySelector(".how-to-use-timing")) return;

        const id = normalizeShopifyId(
            item.getAttribute("data-productid") ||
            item.getAttribute("data-product-id")
        );

        let match = id ? timingById.get(id) : null;

        if (!match) {
            match = [...timingById.values()].find(entry =>
                itemMatchesProductTitle(item, entry.title)
            ) || null;
        }

        if (!match?.label) return;

        const nameEl = getHowToUseNameElement(item, match.title);
        const timingHtml = match.label.split(" / ").filter(Boolean).map(function (part) {
            return `<span class="how-to-use-timing">${part}</span>`;
        }).join(" ");

        if (nameEl) {
            nameEl.insertAdjacentHTML("afterend", ` ${timingHtml}`);
        }
    });
}

function getFallbackSelfieUrl() {
    const input = document.getElementById("recommendation-selfie-fallback");
    return input?.value || "";
}

function hasUsableImageSrc(src) {
    if (!src) return false;
    const value = String(src).trim();
    if (!value || value === "#" || value.indexOf("data:,") === 0) return false;
    return true;
}

function getSelfieImageUrl(data) {
    const fallbackUrl = getFallbackSelfieUrl();

    if (hasUsableImageSrc(data.selfie_url)) {
        return data.selfie_url;
    }

    if (!data.selfie_id) {
        return fallbackUrl;
    }

    const html = data.selfie_html || "";
    if (html) {
        const wrap = document.createElement("div");
        wrap.innerHTML = html;
        const img = wrap.querySelector("img");
        const htmlSrc = img ? (img.getAttribute("src") || img.src || "") : "";

        if (hasUsableImageSrc(htmlSrc)) return htmlSrc;
    }

    return fallbackUrl;
}

function renderSelfieSection(data) {
    const banner = document.getElementById("recommendation-banner");
    if (!banner) return;

    const selfieHtml = getTextSectionHtml(data, "section_selfie");
    const fallbackUrl = getFallbackSelfieUrl();
    const selfieImageUrl = getSelfieImageUrl(data);
    const usingFallback = Boolean(selfieImageUrl) && selfieImageUrl === fallbackUrl;

    if (!selfieHtml.trim() && !selfieImageUrl) {
        banner.innerHTML = "";
        banner.hidden = true;
        return;
    }

    banner.hidden = false;
    banner.innerHTML = `
        <div class="recommendation-banner-wrapper ${selfieImageUrl ? "has-image" : "no-image"}">

            ${selfieImageUrl ? `
                <div class="recommendation-banner-image">
                    <div class="recommendation-selfie-frame">
                        <img
                            id="selfie_img"
                            crossorigin="anonymous"
                            src="${selfieImageUrl}"
                            alt="${usingFallback ? "SKINN" : "Your results"}"
                        >
                        ${data.selfie_id ? `
                            <canvas id="selfie_canvas"></canvas>
                        ` : ""}
                    </div>
                    ${data.selfie_id ? `
                        <div class="highlight-controls" id="highlight-controls" hidden>
                            <button type="button" id="hideHighlight">Hide highlights</button>
                            <button type="button" id="showHighlight">Show highlights</button>
                        </div>
                    ` : ""}
                </div>
            ` : ""}

            ${selfieHtml.trim() || data.selfie_id ? `
                <div class="recommendation-banner-content">
                    ${selfieHtml}
                    ${data.selfie_id ? getSelfieScoresHtml() : ""}
                </div>
            ` : ""}

        </div>
    `;

    const img = banner.querySelector("#selfie_img");
    if (img && fallbackUrl) {
        img.addEventListener("error", () => {
            img.src = fallbackUrl;
            img.alt = "SKINN";
            hideSelfieHighlights();
        });
    }

    const hideBtn = document.getElementById("hideHighlight");
    const showBtn = document.getElementById("showHighlight");
    hideBtn?.addEventListener("click", () => toggleHighlight(false));
    showBtn?.addEventListener("click", () => toggleHighlight(true));
}

function getSelfieScoresHtml() {
    const scores = [
        ["Wrinkles", "Wrinkles", "rgb(24, 96, 3)"],
        ["Rosacea", "Rosacea", "rgb(206, 66, 66)"],
        ["DarkCircles", "Dark Circles", "rgb(28, 30, 82)"],
        ["Acne", "Acne", "rgb(234, 220, 96)"],
        ["DarkSpots", "Dark Spots", "rgb(81, 212, 191)"],
        ["Texture", "Texture", "rgb(186, 111, 223)"]
    ];

    const scoreItems = scores.map(([id, label, color]) => `
        <div class="facemap_single_score_container" id="${id}_Score_container">
            <div class="facemap_score" style="border-color: ${color};" id="${id}_Score"></div>
            <div class="facemap_label">${label}</div>
        </div>
    `).join("");

    return `
        <div id="skin-health-title-container">
            <p id="skin-health-title">Your Skin Health Rating</p>
        </div>
        <div id="facemap_all_scores_container">
            ${scoreItems}
        </div>
        <div id="tangent_score_description">
            *Scores are calculated by our advanced AI system.<br>Scale is 1-100(A higher score means fewer skin concerns detected by our AI).
        </div>
    `;
}

function formatHeading(key) {
    return key
        .replace("section_", "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, c => c.toUpperCase());
}

function getFallbackTiming(index) {
    if (index === 0) {
        return `${sunIcon} AM`;
    }

    return `PM ${halfMoon}`;
}

function createSuggestedAddCard(product) {

    // -----------------------------------------
    // Get first variant from GraphQL response
    // -----------------------------------------

    const firstVariant =
        product?.variants?.edges?.[0]?.node ||
        product?.variants?.[0];

    if (!firstVariant) return "";

    // -----------------------------------------
    // Variant ID
    // -----------------------------------------

    const variantId =
        firstVariant.legacyResourceId ||
        firstVariant.id;

    // -----------------------------------------
    // Selling plan
    // -----------------------------------------

    const sellingPlanId =
        getProductSellingPlanId(product);

    // -----------------------------------------
    // Product URL
    // -----------------------------------------

    const productUrl = product?.handle
        ? `/products/${product.handle}`
        : "#";

    return `
        <div
            class="recommendation-card suggested-add-card"
            data-product-id="${product.id}"
            data-selected-variant="${variantId}"
        >

            ${renderProductImageMarkup(product, productUrl)}

            <div class="recommendation-content">

                <h3 class="product-title">
                    <a href="${productUrl}">
                        ${product.title}
                    </a>
                </h3>

                <div class="product-price">
                    $<span class="price-value">
                        ${firstVariant.price}
                    </span>
                </div>

                <button
                    class="add-to-cart-btn"
                    type="button"
                >
                    Add to Cart
                </button>

                ${sellingPlanId
            ? `
                            <button
                                class="subscribe-btn"
                                type="button"
                                data-selling-plan="${sellingPlanId}"
                            >
                                Subscribe + Save
                            </button>
                        `
            : ""
        }

            </div>

        </div>
    `;
}

function createProductCard(
    concern,
    skinType,
    textureType,
    sectionKey,
    index,
    product,
    routineProductTitle
) {

    // -----------------------------------------
    // Get first variant from GraphQL response
    // -----------------------------------------

    const firstVariant =
        product?.variants?.edges?.[0]?.node ||
        product?.variants?.[0];

    if (!firstVariant) {
        console.warn(
            "Skipping product because no variant was found:",
            product
        );
        return "";
    }

    // -----------------------------------------
    // Shopify numeric variant ID
    // -----------------------------------------

    const variantId =
        firstVariant.legacyResourceId ||
        firstVariant.id;

    // -----------------------------------------
    // Product selling plan
    // -----------------------------------------

    const sellingPlanId =
        getProductSellingPlanId(product);

    // -----------------------------------------
    // Product URL
    // -----------------------------------------

    const productUrl = product?.handle
        ? `/products/${product.handle}`
        : "#";

    // -----------------------------------------
    // Routine config
    // -----------------------------------------

    const config = getRoutineConfigItem(
        concern,
        skinType,
        textureType,
        sectionKey,
        routineProductTitle || product.title
    );

    // -----------------------------------------
    // Default step titles
    // -----------------------------------------

    const defaultStepTitles = {
        section_cleanser: "Step 1 · Cleanser",
        section_exfoliation: "Step 2 · Exfoliation",
        section_treatment_serum: "Step 3 · Treatment",
        section_cream: "Step 4 · Moisturizer",
        section_eye_care: "Step 5 · Eye Care"
    };

    const stepTitle =
        defaultStepTitles[sectionKey] ||
        config?.step ||
        formatHeading(sectionKey);

    const timing = config?.timing || getFallbackTiming(index);
    const timingLabel = formatTimingLabel(timing);

    // -----------------------------------------
    // Card
    // -----------------------------------------

    return `
        <div
            class="recommendation-card"
            data-product-id="${product.id}"
            data-section-key="${sectionKey}"
            data-selected-variant="${variantId}"
            data-available-for-sale="${isAvailableForSale(product, firstVariant) ? "true" : "false"}"
            ${timingLabel ? `data-timing-label="${timingLabel}"` : ""}
        >

            <div class="product-step">
                ${stepTitle}
            </div>

            ${timing ? `
                <div class="product-timing">
                    ${timing}
                </div>
            ` : ""}

            ${renderProductImageMarkup(product, productUrl)}

            <div class="recommendation-content">

                <h3 class="product-title">
                    <a href="${productUrl}">
                        ${product.title}
                    </a>
                </h3>

                <div class="product-price">
                    $<span class="price-value">
                        ${firstVariant.price}
                    </span>
                </div>

                <button
                    class="add-to-cart-btn"
                    type="button"
                >
                    Add to Cart
                </button>

                ${sellingPlanId
            ? `
                            <button
                                class="subscribe-btn"
                                type="button"
                                data-selling-plan="${sellingPlanId}"
                            >
                                Subscribe + Save
                            </button>
                        `
            : ""
        }

            </div>

        </div>
    `;
}

function getVariantImage(product, variant) {
    if (!variant.image_id)
        return product.image?.src || "";
    const image = product.images.find(img => {
        return String(img.id) === String(variant.image_id);
    });
    return image
        ? image.src
        : product.image?.src || "";
}

function attachAddToCartEvents() {

    // =========================================
    // ADD TO CART
    // =========================================

    document.querySelectorAll(".add-to-cart-btn").forEach(button => {

        button.addEventListener("click", async () => {

            const card = button.closest(".recommendation-card");

            const variantId =
                card?.dataset.selectedVariant;

            if (!variantId) {
                console.error("No variant ID found");
                return;
            }

            button.disabled = true;
            const originalText = button.textContent;

            button.textContent = "Adding...";

            try {

                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: [
                            {
                                id: Number(variantId),
                                quantity: 1,
                                properties: {
                                    _from: "tangent_add_to_cart"
                                }
                            }
                        ]
                    })
                });

                const result = await response.json();

                if (!response.ok) {
                    throw new Error(
                        result.description ||
                        "Unable to add product to cart"
                    );
                }

                console.log("Product added to cart:", result);

                button.textContent = "Added ✓";

                // Refresh Shopify cart/drawer
                document.dispatchEvent(
                    new CustomEvent("cart:refresh")
                );

                setTimeout(() => {
                    button.disabled = false;
                    button.textContent = originalText;
                }, 1500);

            } catch (error) {

                console.error("Add to cart error:", error);

                button.disabled = false;
                button.textContent = originalText;

                alert(
                    error.message ||
                    "Unable to add product to cart."
                );
            }

        });

    });


    // =========================================
    // ADD ALL TO CART
    // =========================================

    const addAllButton = document.querySelector(".add-all-to-cart-btn");

    if (addAllButton) {
        addAllButton.addEventListener("click", async () => {
            const items = [];
            const seenVariantIds = {};

            document.querySelectorAll("#recommendation-sections .recommendation-card").forEach(card => {
                const variantId = card.dataset.selectedVariant;
                const addBtn = card.querySelector(".add-to-cart-btn");

                if (!variantId) return;
                if (card.dataset.availableForSale === "false") return;
                if (addBtn && addBtn.disabled) return;

                const id = Number(String(variantId).split("/").pop());
                if (!Number.isFinite(id) || id <= 0 || seenVariantIds[id]) return;

                seenVariantIds[id] = true;
                items.push({
                    id: id,
                    quantity: 1,
                    properties: {
                        _from: "tangent_add_all_to_cart"
                    }
                });
            });

            if (!items.length) return;

            addAllButton.disabled = true;
            const originalText = addAllButton.textContent;
            addAllButton.textContent = "Adding...";

            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: items
                    })
                });

                const result = await response.json();

                if (!response.ok) {
                    throw new Error(
                        result.description ||
                        "Unable to add products to cart"
                    );
                }

                addAllButton.textContent = "Added ✓";

                document.dispatchEvent(
                    new CustomEvent("cart:refresh")
                );

                setTimeout(() => {
                    addAllButton.disabled = false;
                    addAllButton.textContent = originalText;
                }, 1500);
            } catch (error) {
                console.error("Add all to cart error:", error);

                addAllButton.disabled = false;
                addAllButton.textContent = originalText;

                alert(
                    error.message ||
                    "Unable to add products to cart."
                );
            }
        });
    }


    // =========================================
    // SUBSCRIBE
    // =========================================

    document.querySelectorAll(".subscribe-btn").forEach(button => {

        button.addEventListener("click", async () => {

            const card =
                button.closest(".recommendation-card");

            const variantId =
                card?.dataset.selectedVariant;

            const sellingPlanId =
                button.dataset.sellingPlan;

            if (!variantId) {
                console.error("No variant ID found");
                return;
            }

            if (!sellingPlanId) {
                console.error("No selling plan ID found");
                return;
            }

            const cartItem = {
                id: Number(variantId),
                quantity: 1,
                selling_plan: Number(sellingPlanId)
            };

            console.log(
                "Adding subscription:",
                cartItem
            );

            button.disabled = true;
            const originalText = button.textContent;

            button.textContent = "Adding...";

            try {

                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: [cartItem]
                    })
                });

                const result = await response.json();

                if (!response.ok) {
                    throw new Error(
                        result.description ||
                        "Unable to add subscription"
                    );
                }

                console.log(
                    "Subscription added to cart:",
                    result
                );

                button.textContent = "Subscribed ✓";

                // Refresh Shopify cart/drawer
                document.dispatchEvent(
                    new CustomEvent("cart:refresh")
                );

                setTimeout(() => {
                    button.disabled = false;
                    button.textContent = originalText;
                }, 1500);

            } catch (error) {

                console.error(
                    "Subscription error:",
                    error
                );

                button.disabled = false;
                button.textContent = originalText;

                alert(
                    error.message ||
                    "Unable to add subscription."
                );
            }

        });

    });

}

let tangent_facemap_data = null;
let selfieResizeBound = false;

async function getSelfieMapping(selfieId) {
    try {
        const url = `https://service.tangent.ai/shopify/upload-selfie?selfie_id=${selfieId}&user=mango`;
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(response.status);
        }

        const data = await response.json();
        tangent_facemap_data = data?.selfie_record?.[0]?.facemap;

        if (!tangent_facemap_data) return;

        setScores(tangent_facemap_data.scores);

        const img = document.querySelector("#selfie_img");

        if (img) {
            img.onload = function () {
                drawOnCanvas();
                showHighlightControls();
            };

            const facemapUrl = tangent_facemap_data.url;
            if (facemapUrl && img.src !== facemapUrl) {
                img.src = facemapUrl;
            } else if (img.complete && img.naturalWidth) {
                drawOnCanvas();
                showHighlightControls();
            }
        }

        bindSelfieResize();
    } catch (err) {
        console.error("Selfie Mapping Error:", err);
    }
}

function bindSelfieResize() {
    if (selfieResizeBound) return;
    selfieResizeBound = true;
    window.addEventListener("resize", () => {
        if (tangent_facemap_data) drawOnCanvas();
    });
}

function isFallbackSelfieImage(img) {
    const fallbackUrl = getFallbackSelfieUrl();
    if (!img?.src || !fallbackUrl) return false;
    return img.src === fallbackUrl || img.src.includes("Skinnalt");
}

function hideSelfieHighlights() {
    const canvas = document.getElementById("selfie_canvas");
    const controls = document.getElementById("highlight-controls");

    if (canvas) {
        canvas.style.visibility = "hidden";
        canvas.style.display = "none";
    }

    if (controls) {
        controls.hidden = true;
        controls.classList.remove("is-visible");
    }

    hideSelfieScores();
    tangent_facemap_data = null;
}

function hideSelfieScores() {
    document.getElementById("skin-health-title-container")
        ?.style.setProperty("display", "none");
    document.getElementById("facemap_all_scores_container")
        ?.style.setProperty("display", "none");
    document.getElementById("tangent_score_description")
        ?.style.setProperty("display", "none");
}

function setScores(scores) {
    const scoreMap = {
        acne: "Acne",
        rosacea: "Rosacea",
        darkspots: "DarkSpots",
        wrinkles: "Wrinkles",
        dark_circles: "DarkCircles",
        texture: "Texture"
    };

    let concernCount = 0;

    if (!scores) {
        hideSelfieScores();
        return concernCount;
    }

    Object.entries(scores).forEach(([key, value]) => {
        const prefix = scoreMap[key];
        if (!prefix || value == null) return;

        document.getElementById(`${prefix}_Score_container`)
            ?.style.setProperty("display", "flex");

        const scoreElement = document.getElementById(`${prefix}_Score`);
        if (scoreElement) {
            scoreElement.textContent = `${value}%`;
        }

        concernCount++;
    });

    const display = concernCount > 0 ? "flex" : "none";
    const titleDisplay = concernCount > 0 ? "block" : "none";

    document.getElementById("facemap_all_scores_container")
        ?.style.setProperty("display", display);
    document.getElementById("skin-health-title-container")
        ?.style.setProperty("display", titleDisplay);
    document.getElementById("tangent_score_description")
        ?.style.setProperty("display", titleDisplay);

    return concernCount;
}

function drawOnCanvas() {
    if (!tangent_facemap_data) return;

    const canvas = document.querySelector("#selfie_canvas");
    const img = document.querySelector("#selfie_img");

    if (!canvas || !img) return;
    if (isFallbackSelfieImage(img)) {
        hideSelfieHighlights();
        return;
    }

    const ctx = canvas.getContext("2d");
    const imgRect = img.getBoundingClientRect();
    const wrapperRect = img.parentElement.getBoundingClientRect();
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;

    if (!naturalWidth || !naturalHeight) return;

    if (!img.clientWidth || !img.clientHeight) {
        requestAnimationFrame(drawOnCanvas);
        return;
    }

    const imageRatio = naturalWidth / naturalHeight;
    const boxRatio = img.clientWidth / img.clientHeight;

    let renderedWidth;
    let renderedHeight;

    if (imageRatio > boxRatio) {
        renderedWidth = img.clientWidth;
        renderedHeight = renderedWidth / imageRatio;
    } else {
        renderedHeight = img.clientHeight;
        renderedWidth = renderedHeight * imageRatio;
    }

    canvas.style.width = `${renderedWidth}px`;
    canvas.style.height = `${renderedHeight}px`;
    canvas.width = naturalWidth;
    canvas.height = naturalHeight;
    canvas.style.left =
        `${imgRect.left - wrapperRect.left + (imgRect.width - renderedWidth) / 2}px`;
    canvas.style.top =
        `${imgRect.top - wrapperRect.top + (imgRect.height - renderedHeight) / 2}px`;
    canvas.style.visibility = "visible";
    canvas.style.display = "block";

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const prop = naturalWidth / 400;

    drawDarkCircleContours(
        ctx,
        tangent_facemap_data.dark_circles || [],
        getDarkCircleBlur(prop)
    );
    drawWrinkleContours(
        ctx,
        tangent_facemap_data.wrinkles || [],
        getWrinkleLineWidth(prop)
    );
    drawRosaceaContours(
        ctx,
        tangent_facemap_data.rosacea || [],
        getRosaceaBlur(prop)
    );
    drawTextureContours(
        ctx,
        tangent_facemap_data.texture || [],
        getTextureLineWidth(prop)
    );
    drawDarkSpotsContours(
        ctx,
        tangent_facemap_data.darkspots || [],
        getDarkSpotsLineWidth(prop)
    );
    drawAcneContours(
        ctx,
        tangent_facemap_data.acne || [],
        getAcneLineWidth(prop)
    );
}

function showHighlightControls() {
    const controls = document.getElementById("highlight-controls");
    const hideBtn = document.getElementById("hideHighlight");
    const showBtn = document.getElementById("showHighlight");

    if (!controls || !hideBtn || !showBtn) return;

    controls.hidden = false;
    controls.classList.add("is-visible");
    hideBtn.style.display = "inline";
    showBtn.style.display = "none";
}

function toggleHighlight(show) {
    const canvas = document.getElementById("selfie_canvas");
    const hideBtn = document.getElementById("hideHighlight");
    const showBtn = document.getElementById("showHighlight");

    if (!canvas || !hideBtn || !showBtn) return;

    if (show) {
        canvas.style.display = "block";
        hideBtn.style.display = "inline";
        showBtn.style.display = "none";
    } else {
        canvas.style.display = "none";
        hideBtn.style.display = "none";
        showBtn.style.display = "inline";
    }
}

function getDarkCircleBlur(prop) {
    if (prop < 1) return "blur(1px)";
    if (prop < 1.5) return "blur(2px)";
    if (prop < 2) return "blur(4px)";
    if (prop < 3) return "blur(7px)";
    if (prop < 4) return "blur(12px)";
    return "blur(12px)";
}

function getRosaceaBlur(prop) {
    if (prop < 1) return "blur(4px)";
    if (prop < 1.5) return "blur(4px)";
    if (prop < 2) return "blur(5px)";
    if (prop < 3) return "blur(13px)";
    if (prop < 4) return "blur(18px)";
    return "blur(18px)";
}

function getAcneLineWidth(prop) {
    if (prop < 0.5) return 2;
    if (prop < 1) return 4;
    if (prop < 1.5) return 7;
    if (prop < 2) return 10;
    if (prop < 3) return 14;
    if (prop < 4) return 15;
    return 15;
}

function getDarkSpotsLineWidth(prop) {
    if (prop < 1) return 1;
    if (prop < 1.5) return 6;
    if (prop < 2) return 6;
    if (prop < 3) return 14;
    if (prop < 4) return 15;
    return 15;
}

function getTextureLineWidth(prop) {
    if (prop < 0.5) return 2;
    if (prop < 1) return 3;
    if (prop < 1.5) return 6;
    if (prop < 2) return 10;
    if (prop < 3) return 14;
    if (prop < 4) return 16;
    return 20;
}

function getWrinkleLineWidth(prop) {
    if (prop < 1) return 4;
    if (prop < 1.5) return 6;
    if (prop < 2) return 10;
    if (prop < 3) return 15;
    if (prop < 4) return 30;
    return 30;
}

const drawDarkCircleContours = (context, contours, filter) => {
    context.filter = filter;
    context.fillStyle = "rgba(28, 30, 82, 0.3)";
    drawContours(context, contours, true, false);
};

const drawWrinkleContours = (context, contours, lineWidth) => {
    context.filter = "none";
    context.fillStyle = "rgba(24, 96, 3, 0.5)";
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(24, 96, 3, 0.5)";
    drawContours(context, contours, true, true);
};

const drawRosaceaContours = (context, contours, filter) => {
    context.filter = filter;
    context.fillStyle = "rgba(206, 66, 66, 0.5)";
    drawContours(context, contours, true, false);
};

const drawTextureContours = (context, contours, lineWidth) => {
    context.filter = "none";
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(186, 111, 223, 0.5)";
    drawContours(context, contours, false, true);
};

const drawDarkSpotsContours = (context, contours, lineWidth) => {
    context.filter = "none";
    context.fillStyle = "rgba(81, 212, 191, 0.4)";
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(81, 212, 191, 0.4)";
    drawContours(context, contours, true, false);
};

const drawAcneContours = (context, contours, lineWidth) => {
    context.filter = "none";
    context.fillStyle = "rgba(234, 220, 96, 0.4)";
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(234, 220, 96, 0.4)";
    drawContours(context, contours, true, false);
};

const drawContours = (context, contours, fill, stroke) => {
    if (!Array.isArray(contours)) return;

    for (let i = 0; i < contours.length; i++) {
        drawContour(context, contours[i], fill, stroke);
    }
};

const drawContour = (context, contourCoordinates, fill = false, stroke = false) => {
    if (!Array.isArray(contourCoordinates)) return;

    context.beginPath();

    for (let i = 0; i < contourCoordinates.length; i++) {
        const point = contourCoordinates[i];
        if (!point || point.length < 2) continue;

        if (i === 0) {
            context.moveTo(point[0], point[1]);
        } else {
            context.lineTo(point[0], point[1]);
        }
    }

    context.closePath();
    if (fill) context.fill();
    if (stroke) context.stroke();
};
